import { call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  createCaseFail,
  createCaseSuccess,
  CREATE_CASE,
  updateCaseFail,
  updateCaseSuccess,
  UPDATE_CASE
} from '../../redux/actions/cm/caseCreation';
import {
  createCase as createCaseService,
  updateCase as updateCaseService
} from '../../services/cm/cases';

function* createCaseWorker({ name, note, customers, dept, customFields }) {
  try {
    const { caseId } = yield call(createCaseService, {
      name,
      note,
      customers,
      dept,
      customFields
    });
    yield put(createCaseSuccess({ caseId }));
  } catch (error) {
    yield put(createCaseFail(error.message));
  }
}

export function* watchCreateCase() {
  yield takeEvery(
    CREATE_CASE,
    function* ({ payload: { name, note, customers, dept, customFields } }) {
      yield fork(createCaseWorker, {
        name,
        note,
        customers,
        dept,
        customFields
      });
    }
  );
}

function* updateCaseWorker(payload) {
  try {
    const { caseId } = yield call(updateCaseService, payload);
    yield put(updateCaseSuccess({ caseId }));
  } catch (error) {
    yield put(updateCaseFail(error.message));
  }
}

export function* watchUpdateCase() {
  yield takeEvery(UPDATE_CASE, function* ({ payload }) {
    yield fork(updateCaseWorker, payload);
  });
}
